
    import Vue from "vue";

    const END_POINT = "/student";

    const getStudent = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllStudents = data => Vue.axios.get(END_POINT, {params: data});

    const createStudent = student => Vue.axios.post(END_POINT+'/v2',  student );

    const createAllStudents = Students => Vue.axios.post(END_POINT + "/all",  Students );

    const updateStudent = student => Vue.axios.put(END_POINT  + "/" + student.id,  student );

    const deleteStudent = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getStudent,
      getAllStudents,
      createStudent,
      createAllStudents,
      updateStudent,
      deleteStudent
    };
    